import { call, put, select, takeLatest } from 'redux-saga/effects';

import { theme, createStandaloneToast } from '@frontend/legacy-components';

import * as opDefActions from 'modules/opDefs/data/actions';
import * as opDefSelectors from 'modules/opDefs/data/reducer';

import service from 'services/opDefService';

import history from 'utils/browserHistory';
import { getErrorMessage } from 'utils/stringUtils';

import CopyOperationSuccessNotification from '../CopyOperationSuccessNotification';
import * as actions from './actions';

const { types } = actions;
const { toast } = createStandaloneToast({ theme });

export default function* root() {
  yield takeLatest(types.DELETE_REQUEST, watchDelete);
  yield takeLatest(types.COPY_REQUEST, watchCopy);
}

export function* initOpDefDetailsPage({ match }) {
  const opDefId = match.params.opDefId;
  const opDef = yield call(service.getOpDef, opDefId);
  yield put(opDefActions.receiveOpDef({ opDef }));
}

function* watchDelete() {
  try {
    const { id: opDefId } = yield select(opDefSelectors.getOpDef);
    yield call(service.deleteOpDef, opDefId);
    yield put(actions.deleteOpDef.success());
    history.push('/processes/operations');
    yield call(toast, {
      title: 'Success',
      status: 'success',
      description: 'Operation was successfully deleted.',
    });
  } catch (error) {
    yield put(actions.deleteOpDef.error());
    yield call(toast, {
      status: 'error',
      title: 'Error',
      description: getErrorMessage(error),
    });
  }
}

function* watchCopy() {
  try {
    const opDef = yield select(opDefSelectors.getOpDef);
    const { name, id } = yield call(service.copyOpDef, opDef.id);
    yield put(actions.copyOpDef.success());
    toast({
      status: 'success',
      title: 'Success',
      description: <CopyOperationSuccessNotification id={id} name={name} />,
    });
  } catch (error) {
    yield put(actions.copyOpDef.error({ error }));
  }
}
